import { render, staticRenderFns } from "./assignedProjectsYam.vue?vue&type=template&id=3ad846e1&"
import script from "./assignedProjectsYam.vue?vue&type=script&lang=js&"
export * from "./assignedProjectsYam.vue?vue&type=script&lang=js&"
import style0 from "./assignedProjectsYam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports